import {
  BulletListInterface,
  ButtonInterface,
  EntityTypes,
  HorizontalLineInterface,
  ImageInterface,
  SectionInterface,
  TextInterface,
} from '@email-editor/ui'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { emailSelectors, useEmail } from '../../../../store'
import * as managementActions from '../../../../store/management/actions'
import { SettingsTitle } from './components/common/SettingsTitle'
import ButtonSettings from './entities/ButtonSettings'
import HorizontalLineSettings from './entities/HorizontalLineSettings'
import ImageSettings from './entities/ImageSettings'
import SectionSettings from './entities/SectionSettings'
import TextSettings from './entities/TextSettings'

type EntitySettingsProps = {
  entityId: string
}

const EntitySettings = ({ entityId }: EntitySettingsProps) => {
  const entity = useEmail(email => emailSelectors.getEntityById(email, entityId))

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const closeSettings = () => dispatch(managementActions.setEditingEntityId(null))

  if (!entity) {
    return null
  }

  let entityComponent

  switch (entity.type) {
    case EntityTypes.Section:
      const section = entity as SectionInterface
      entityComponent = <SectionSettings entity={section} />
      break
    case EntityTypes.Text:
      const text = entity as TextInterface
      entityComponent = <TextSettings entity={text} />
      break
    case EntityTypes.Button:
      const button = entity as ButtonInterface
      entityComponent = <ButtonSettings entity={button} />
      break
    case EntityTypes.HorizontalLine:
      const horizontalLine = entity as HorizontalLineInterface
      entityComponent = <HorizontalLineSettings entity={horizontalLine} />
      break
    case EntityTypes.Image:
      const image = entity as ImageInterface
      entityComponent = <ImageSettings entity={image} />
      break
    default:
      entityComponent = <div>{entity.type}</div>
  }

  return (
    <>
      <SettingsTitle onBack={closeSettings}>
        {t(`entity_settings.${entity.type.toLowerCase()}.title`)}
      </SettingsTitle>
      <div className="customScroll overflow-y-auto">{entityComponent}</div>
    </>
  )
}

export default EntitySettings
